import { decryptV3App, decryptV3H5 as decryptV3H5Bridge} from '../../jsbridge'
import { getEdchKeySession, buildCredentialHeaders } from './header'
import { checkResponseSignature } from './encryption';
import { omit } from 'lodash';
import { AxiosResponse } from 'axios';
import { isInApp } from '../../browser'


// start_ai_generated
export const handleV3Response = async (response: AxiosResponse<any>) => {
  let _data = response.data || {};
  // 如果是在app 调用app的解密方法
  if (await isInApp()) {
    if (typeof _data === 'string') {
      _data = await decryptV3App({ type: 0, data: _data });
    } else if (typeof _data?.data === 'string') {
      _data = {
        ...omit(_data, ['data']),
        data: await decryptV3App({ type: 0, data: _data.data })
      };
    }
  } else {
    // 如果是在h5 调用h5的解密方法
    const ecdhKey = await getEdchKeySession();
    const { randomField } = buildCredentialHeaders();
    if (!ecdhKey || !checkResponseSignature(ecdhKey.shareKey, randomField, _data)) {
      return Promise.reject({ ...response, message: 'signature mismatch' });
    }
    if (typeof _data === 'string') {
      _data = await decryptV3H5(_data, ecdhKey.shareKey);
    } else if (typeof _data?.data === 'string') {
      _data = {
        ...omit(_data, ['data']),
        data: await decryptV3H5(_data.data, ecdhKey.shareKey)
      };
    }
  }
  return _data;
};
// end_ai_generated

/**
 * 解密v3 h5
 * @param data
 * @param shareKey 协商key
 * @returns
 */
export async function decryptV3H5<T = any>(data: string, shareKey?: string) {
  shareKey = shareKey || (await getEdchKeySession())?.shareKey;
  return decryptV3H5Bridge(data, shareKey)
    .catch((e) => {
      // 解密失败 返回原始数据
      return Promise.resolve(data)
    }) as Promise<T>
}
